import { Select } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { getArticleGroupNumberString } from "@msuite/utils/stock";
import type { Control, FieldValues, Path } from "react-hook-form";
import { client } from "@/hono";

/** Props Interface */
interface ArticleGroupSelectProps<T extends FieldValues> {
	control: Control<T>;
	name: Path<T>;
}

export function ArticleGroupSelect<T extends FieldValues>({
	control,
	name,
}: ArticleGroupSelectProps<T>) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { data } = useQuery({
		queryKey: ["article-groups"],
		queryFn: async () => {
			const response = await client.stock["article-groups"].$get();
			const data = await responseHandler(response);
			return data.articleGroups;
		},
	});

	/** Render */
	return (
		<Select
			label={t("stock.article_group")}
			control={control}
			isNullable={false}
			name={name}
			isRequired
			options={guardArray(data).map((item) => ({
				label: `${getArticleGroupNumberString(item.number)} / ${item.name}`,
				value: item.id,
				item: { item },
			}))}
			data-cy="article-group-select"
		/>
	);
}
